import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(lang)/organizations/(orgLayoutGroup)/loading.jsx");
